"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = require("./Box");
var createResponsive_1 = require("./utils/createResponsive");
var Text_1 = __importDefault(require("./Text"));
function styleConfig(option, theme) {
    var baseStyle = {
        fontWeight: theme.fontWeights.bold,
        letterSpacing: '0.02em',
        textTransform: 'uppercase'
    };
    switch (option) {
        case 'L1':
            return __assign(__assign({}, baseStyle), { fontSize: '18px', lineHeight: '24px' });
        case 'L2':
            return __assign(__assign({}, baseStyle), { fontSize: '16px', lineHeight: '20px' });
        case 'L3':
            return __assign(__assign({}, baseStyle), { fontSize: '14px', lineHeight: '16px' });
        case 'L4':
            return __assign(__assign({}, baseStyle), { fontSize: '12px', lineHeight: '16px' });
        default:
            return {};
    }
}
var L1 = (0, Box_1.createBasicComponentWith)(Text_1.default, function (props) { return styleConfig('L1', props.theme); });
L1.displayName = 'Label.L1';
var L2 = (0, Box_1.createBasicComponentWith)(Text_1.default, function (props) { return styleConfig('L2', props.theme); });
L2.displayName = 'Label.L2';
var L3 = (0, Box_1.createBasicComponentWith)(Text_1.default, function (props) { return styleConfig('L3', props.theme); });
L3.displayName = 'Label.L3';
var L4 = (0, Box_1.createBasicComponentWith)(Text_1.default, function (props) { return styleConfig('L4', props.theme); });
L4.displayName = 'Label.L4';
var Responsive = (0, createResponsive_1.createResponsiveText)(styleConfig);
Responsive.displayName = 'Label.Responsive';
var Label = {
    L1: L1,
    L2: L2,
    L3: L3,
    L4: L4,
    Responsive: Responsive
};
exports.default = Label;
